import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// Route-level code splitting (src/lazyRoute.tsx): the module's route table and screens load on first visit
const ReputationRoutes = lazyRoute(() => import('./ReputationRoutes').then((m) => m.ReputationRoutes));
const PublicReviewPage = lazyRoute(() => import('./PublicReviewPage').then((m) => m.PublicReviewPage));

/** The Reputation module, under /agencies/:agencyId/reputation */
export const reputationAgencyRoutes = <Route path="reputation/*" element={<ReputationRoutes />} />;

/** The review page every review request links to (no sign-in) */
export const reputationPublicRoutes = <Route path="/review/:token" element={<PublicReviewPage />} />;
